import {
  randCompanyName,
  randEmail,
  randPhoneNumber,
  randStreetAddress,
} from '@ngneat/falso';
import {
  ContactCollection,
  IBrand,
  IContact,
  IContactable,
  IMedia,
  IPractice,
} from '@principle-theorem/principle-core/interfaces';
import {
  CollectionReference,
  DocumentReference,
  Firestore,
  initFirestoreModel,
  IReffable,
  subCollection,
} from '@principle-theorem/shared';

export class Contactable {
  static init(overrides?: Partial<IContactable>): IContactable {
    return {
      name: '',
      email: '',
      address: '',
      phone: '',
      notes: [],
      tags: [],
      interactions: [],
      metadata: {},
      ...overrides,
    };
  }
}

export class Contact {
  static init(overrides?: Partial<IContact>): IContact {
    return {
      ...Contactable.init(),
      mobileNumber: '',
      ...initFirestoreModel(),
      ...overrides,
    };
  }

  static storagePath(contact: IReffable<IContact>): string {
    return contact.ref.path;
  }

  static mediaCol(patient: IReffable<IContact>): CollectionReference<IMedia> {
    return subCollection<IMedia>(patient.ref, ContactCollection.Media);
  }

  static brandRef(contact: IReffable<IContact>): DocumentReference<IBrand> {
    const practice = Firestore.getParentDocRef<IPractice>(contact.ref);
    return Firestore.getParentDocRef<IBrand>(practice.path);
  }
}

export function MockContact(name?: string): IContact {
  return Contact.init({
    name: name ? name : randCompanyName(),
    email: randEmail(),
    phone: randPhoneNumber(),
    address: randStreetAddress(),
  });
}

export const CONTACTS: IContact[] = ['ACME Inc.', 'Titanium Craniums'].map(
  (company: string) => MockContact(company)
);
